/**
 * 공통 HTTP 에러 카탈로그
 *
 * 프로젝트 고유 에러 코드가 필요하면 spread로 확장한다.
 *
 * @example
 * // 그대로 사용
 * import { throwHttpError } from "@sunkim4638/admin-modules/http";
 * throwHttpError("NOT_FOUND", "회원을 찾을 수 없습니다.");
 *
 * @example
 * // 확장해서 사용
 * import { createHttpErrors, createApiWrapper, ErrorCatalog } from "@sunkim4638/admin-modules/http";
 *
 * const MyErrorCatalog = {
 *   ...ErrorCatalog,
 *   PAYMENT_FAILED: { status: 402, message: "결제에 실패했습니다." },
 * } as const;
 *
 * export const { throwHttpError, errorHandler } = createHttpErrors(MyErrorCatalog);
 * export const apiWrapper = createApiWrapper(errorHandler);
 */

export const ErrorCatalog = {
    BAD_REQUEST:        { status: 400, message: "잘못된 요청입니다." },
    UNAUTHORIZED:       { status: 401, message: "인증이 필요합니다." },
    FORBIDDEN:          { status: 403, message: "권한이 없습니다." },
    NOT_FOUND:          { status: 404, message: "데이터를 찾을 수 없습니다." },
    CONFLICT:           { status: 409, message: "이미 존재하는 데이터입니다." },
    UNPROCESSABLE:      { status: 422, message: "처리할 수 없는 요청입니다." },
    INTERNAL_ERROR:     { status: 500, message: "서버 오류가 발생했습니다." },
    SERVICE_UNAVAILABLE:{ status: 503, message: "서비스를 일시적으로 사용할 수 없습니다." },
} as const;

export type ErrorKey = keyof typeof ErrorCatalog;
